import url from './url';



export default url(({ popupId = ':popupId' }) => `/popups/${popupId}/view`);
